<div class="image-crop-dialog" mat-dialog-content>
  <div class="dialog-header">
    <div class="dialog-title-custom">
      {{ "APP.IMAGE_CROP_DIALOG.TITLE" | translate }}
    </div>
    <div class="close-button-custom">
      <i class="far fa-times icon-regular" (click)="close()"></i>
    </div>
  </div>

  <div class="dialog-body">
    <div class="image-cropper-cont">
      <image-cropper
        [imageBase64]="imageBase64"
        [maintainAspectRatio]="!!aspectRatio ? true : false"
        [aspectRatio]="aspectRatio"
        [resizeToWidth]="resizeToWidth"
        [allowMoveImage]="true"
        [(transform)]="transform"
        format="png"
        output="base64"
        (imageCropped)="onImageCropped($event)"
      ></image-cropper>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions minimal-actions">
    <div class="zoom-slider-cont">
      <i
        class="far fa-magnifying-glass-minus icon-small"
        (click)="onZoom(scale - 0.1)"
      ></i>
      <mat-slider class="slider" [max]="2" [min]="0.5" [step]="0.1">
        <input
          matSliderThumb
          [(ngModel)]="scale"
          #slider
          (ngModelChange)="onZoom($event)"
        />
      </mat-slider>
      <i
        class="far fa-magnifying-glass-plus icon-regular"
        (click)="onZoom(scale + 0.1)"
      ></i>
    </div>

    <button class="btn btn-primary-text" (click)="reset()">
      {{ "APP.RESET" | translate }}
    </button>
    <div class="btn btn-primary" (click)="confirm()">
      {{ "APP.CONFIRM" | translate }}
    </div>
  </div>
</div>
